/* Product page desktop: measure where the grey card starts so it can fill the rest of the screen */
(function () {
  function fit() {
    var card = document.querySelector('.product.grid--2-col-tablet');
    if (!card) return;
    var top = card.getBoundingClientRect().top + window.scrollY;
    document.documentElement.style.setProperty('--jr-pdp-top', Math.max(80, Math.min(top, 320)) + 'px');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fit); else fit();
  window.addEventListener('load', fit);
  window.addEventListener('resize', fit);
})();
